export const DELETE_FROM_STORE = { __delete: true };
